module.exports = __webpack_public_path__ + "media/images/press_kit/test/login/1_b-31d6cfe0d16ae931b73c59d7e0c089c0.png";